<template>
    <li
        class="col-sm-12"
        @click="toggleOpenElement"
        :class="getClassName">
        <span :class="{'clickable': isClickable}">
            <strong>
                <span class="air me-2">
                    <span v-if="element.description"
                          :class="{'fas fa-caret-right animate-300' : !expanded, 'fas fa-caret-right fa-smooth-rotate-90 animate-300' : expanded}"></span>
                </span>
                <span>{{ element.element_full_name }}</span>
                <span class="badge bg-info-subtle ms-2" v-if="getCompetancyEvalText">{{ getCompetancyEvalText }}</span>
            </strong>
        </span>
        <div
            :class="{ 'animate-300 hidden-div': !expanded, 'animate-500 toggled-div': expanded }"
            v-if="element.description">
            <div class="rounded px-3 bg-light-gray py-3 shadow-subtle m-2">
                <div><span v-html="element.description"></span></div>
            </div>
        </div>
    </li>
</template>

<script setup>
import { ref, computed } from 'vue';
import Store from "../../state/teachingCardStore";

const props = defineProps(['element']);
const expanded = ref(false);

const getClassName = computed(() => {
    let className = '';
    if (!props.element.is_approved) {
        return className;
    }
    return className + ' success';
});

const isClickable = computed(() => {
    return props.element.description;
});

const getCompetancyEvalText = computed(() => {
    switch (props.element.competency_eval) {
        case 2: // Not Approved
            return $t('Lærerens tilrådning: Fortsette i nåværende trinn');
        case 1: // Approved
        default: // No evaluation
            return null;
    }
});

function toggleOpenElement() {
    expanded.value = !expanded.value;
}
</script>

<style scoped>

</style>